import { render, staticRenderFns } from "./viewpoint.html?vue&type=template&id=531a1021&scoped=true&lang=html&external"
import script from "./viewpoint.js?vue&type=script&lang=js&external"
export * from "./viewpoint.js?vue&type=script&lang=js&external"
import style0 from "./viewpoint.scss?vue&type=style&index=0&id=531a1021&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531a1021",
  null
  
)

export default component.exports